<template>
    <VCheckbox
        v-model="val"
        :density="density"
        :hint="hint"
        :messages="messages"
        :disabled="disabled"
        :readonly="readonly"
        :errorMessages="errorMessages">
        <template #label>
            <slot />
        </template>
    </VCheckbox>
</template>

<script lang="ts">
    import { defineComponent, watch, ref, PropType } from 'vue';
    import { VCheckbox } from 'vuetify/components';
    import { Density } from './Checkbox.interfaces';

    export default defineComponent({
        name: 'Checkbox',
        components: { VCheckbox },
        emits: ['update:modelValue'],
        props: {
            modelValue: Boolean,
            hint: String,
            disabled: { type: Boolean as PropType<boolean>, default: false },
            readonly: { type: Boolean as PropType<boolean>, default: false },
            messages: { type: Array as PropType<string[]> },
            errorMessages: {
                type: [Array, String] as PropType<string[] | string>,
            },
            density: { type: String as PropType<Density>, default: 'default' },
        },
        setup(props, { emit }) {
            const val = ref<boolean | undefined>(props.modelValue);

            watch(
                () => props.modelValue,
                (newValue, prevValue) => {
                    if (newValue !== prevValue) {
                        val.value = newValue;
                    }
                }
            );

            watch(
                () => val.value,
                (newValue, prevValue) => {
                    if (newValue !== prevValue) {
                        emit('update:modelValue', newValue);
                    }
                }
            );

            return {
                val,
            };
        },
    });
</script>
